export default "__VITE_ASSET__3b5ff11f__"